import EmailTriggerComponent from '../Components/Email/EmailTriggerComponent';

function EmailTriggerPage() {
  return <EmailTriggerComponent />;
}

export default EmailTriggerPage;
